import styled from "styled-components";

export const RecommendedCardTitle = styled.h4`
  margin: 0 0 0.25rem;
  font-size: 16px;
  font-weight: bold;
  color: #000;
`;

export const RecommendedCard = styled.div`
  position: relative;
  min-width: 13.75rem;
  max-width: 15rem;
  height: 17rem;
  background-color: #fff;
  border-radius: 1rem;
  box-shadow: 0 0.125rem 0.5rem rgba(0, 0, 0, 0.08);
  flex-shrink: 0;
  padding: 1rem;
  text-align: left;
  scroll-snap-align: center;
  transition: box-shadow 0.2s ease;
  display: flex;
  flex-direction: column;

  &:hover {
    box-shadow: 0 0.375rem 1rem rgba(0, 0, 0, 0.12);
  }
`;

export const RecommendedCardImage = styled.img`
  width: 100%;
  height: 120px;
  object-fit: cover;
  border-radius: 12px;
  margin-bottom: 0.75rem;
`;

export const RecommendedCardDescription = styled.p`
  font-size: 13px;
  color: #666;
  margin: 0 0 0.75rem;
  line-height: 1.4;
  min-height: 5em;
  max-height: 5em;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  text-overflow: ellipsis;
`;

export const RecommendedCardFooter = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: auto;
`;

export const RecommendedCardIcons = styled.div`
  display: flex;
  align-items: center;
  gap: 0.75rem;

  svg {
    color: black;
    cursor: pointer;
    transition: color 0.2s;

    &:hover {
      color: #fe2f67;
    }
  }
`;

export const RecommendedCardButton = styled.button`
  background-color: #fe2f67;
  color: #fff;
  border: none;
  padding: 1.5% 15%;
  border-radius: 20px;
  font-size: 14px;
  cursor: pointer;
  transition: background-color 0.2s, box-shadow 0.2s;

  box-shadow: rgba(0, 0, 0, 0.3) 2px 3px 4px;

  &:hover {
    background-color: #e62b5f;
    box-shadow: rgba(0, 0, 0, 0.3) 3px 5px 6px;
  }
`;